"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var android_message_listener_1 = require("./android-message-listener");
var AndroidDeeplink = (function () {
    function AndroidDeeplink(androidWindow) {
        this.androidWindow = androidWindow;
        this.data = androidWindow.Android.getDeeplinkParam();
    }
    AndroidDeeplink.prototype.onDeeplink = function (eventHandler) {
        var _this = this;
        this.deeplinkHandler = eventHandler;
        android_message_listener_1.AndroidMessageListener.getInstance(this.androidWindow).registerMessageListener('deeplink', function (data) {
            _this.data = data;
            if (_this.deeplinkHandler) {
                _this.deeplinkHandler(data);
            }
        });
    };
    return AndroidDeeplink;
}());
exports.AndroidDeeplink = AndroidDeeplink;
